<template lang="html">
  <div class="question-container">
    <div class="close-icon-div">
      <v-btn flat icon @click = "$emit('close')"><i class="close-icon"></i></v-btn>
      <span class="question-number">{{ `${index+1} / ${totalNumberOfQuestion}` }}</span>
    </div>
    <div class="title--txt">
      <vue-markdown :source = "taskCompletionItem.task_completion_text">{{ taskCompletionItem.task_completion_text }}</vue-markdown>
    </div>
    <div class="welcome-txt">
      <v-btn large class="upload white--text" @click="onFilePick">Upload File</v-btn>
      <input
        @change="onFilePicked"
        type="file"
        accept="*/*"
        style="display: none;"
        ref="upload"
      >
    </div>
    <div class="button-container">
      <v-btn flat small class="edit" @click = "$emit('previous')"><span>Back</span></v-btn>
      <v-btn :disabled="!fileUploadSuccessful" large @click = "$emit('next'); submitTaskCompletionItemValue();" class="next-button">Next</v-btn>
    </div>
  </div>
</template>

<script>
import uploader from '@/mixins/uploader';
import VueMarkdown from 'vue-markdown';

export default {
  components: {
    VueMarkdown,
  },
  mixins: [uploader],
  data() {
    return {
      totalNumberOfQuestion: null,
      fileUploadSuccessful: false,
      dataObjectId: null,
    };
  },
  props: {
    index: {
      type: Number,
    },
  },
  methods: {
    onFilePick() {
      this.$refs.upload.click();
    },
    onFilePicked(event) {
      const files = event.target.files;
      const file = files[0];
      // TODO: what to do while the image is loading
      // upload function is present in the upload mixin
      this.uploadMedia(file,
        { task_completion_item_id: this.taskCompletionItem.task_completion_item_id })
        .then((mediaObject) => {
          this.dataObjectId = mediaObject.data_object_id;
          this.fileUploadSuccessful = true;
        });
    },
    submitTaskCompletionItemValue() {
      this.$store.dispatch('completionQuestions/submitTaskCompletionItem', {
        data_id: this.dataObjectId,
        task_completion_item_id: this.taskCompletionItem.task_completion_item_id,
      });
      this.defaultState();
    },
    defaultState() {
      this.dataObjectId = null;
    },
  },
  computed: {
    taskCompletionItem() {
      const items = this.$store.getters['completionQuestions/taskCompletionList'] || [];
      this.totalNumberOfQuestion = items.length;
      return items[this.index];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
@import "~styles/completion_questions.scss";

#app {
  .button-container {
    flex-grow: 2;
  }

  .upload {
    border-radius: 24px;
    background: $primary;
    font-family: MuseoSans-900;
    font-size: 16px;
  }

  .title--txt {
    flex-grow: 8;
  }
  .welcome-txt {
    flex-grow: 14;
  }

  @media only screen and (min-width:500px) {
    .button-container {
      text-align: center;
    }
  }

  @media only screen and (max-width:499px) {
    .question-number {
      margin-left: 33%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionsTypes/FileUpload.vue